import React from "react";

/**
 * LinkedValue — wraps its content in a new-tab link when an href is available
 * (server-built, from an entity's `links`), so the operator can confirm the right
 * entity before merging it away. Falls back to plain text when no sensible link
 * target exists, which is why every caller can hand it a possibly-null href.
 *
 * Shared by the merge preview cards and the duplicates list so both open candidates
 * the same way.
 */
function LinkedValue({ href, testid, children }) {
  if (!href) return children;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid}>
      {children}
    </a>
  );
}

export default LinkedValue;
